interface ClarityConfig {
  projectId: string;
}

class ClarityService {
  private config: ClarityConfig;

  constructor() {
    this.config = {
      projectId: import.meta.env.VITE_POS_DASHBOARD_CLARITY_PROJECT_ID || '',
    };
  }

  /**
   * Initialize Microsoft Clarity tracking
   */
  init(): void {
    if (!this.config.projectId) {
      console.warn(
        'Clarity Project ID not provided. Clarity tracking will not be initialized.'
      );
      return;
    }

    // Check if Clarity is already initialized
    if ((window as any).clarity) {
      console.log('Clarity is already initialized');
      return;
    }

    // Initialize Clarity
    (function (c: any, l: Document, a: string, r: string, i: string) {
      c[a] =
        c[a] ||
        function (...args: any[]) {
          (c[a].q = c[a].q || []).push(args);
        };
      const t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = 'https://www.clarity.ms/tag/' + i;
      const y = l.getElementsByTagName(r)[0];
      y.parentNode?.insertBefore(t, y);
    })(window, document, 'clarity', 'script', this.config.projectId);

    console.log(
      'Clarity tracking initialized with project ID:',
      this.config.projectId
    );
  }

  /**
   * Get the current Clarity configuration
   */
  getConfig(): ClarityConfig {
    return { ...this.config };
  }

  /**
   * Check if Clarity is enabled (has project ID)
   */
  isEnabled(): boolean {
    return !!this.config.projectId;
  }
}

// Create and export a singleton instance
export const clarityService = new ClarityService();

// Export the class for testing purposes
export { ClarityService };
